import { formatDashedNumber } from './strings';

export const getFormattedSalary = (salaryObj, defaultFrequency = null) => {
	let salaryFrequency = salaryObj.frequency.split('-')[1] || defaultFrequency || 'month';
	salaryFrequency = salaryFrequency[0].toUpperCase() + salaryFrequency.slice(1);
	let salary;
	if (salaryObj.min === salaryObj.max)
		salary = `${formatDashedNumber(salaryObj.min)} ${salaryObj.currency}/${salaryFrequency}`;
	else if (!salaryObj.max) salary = `${formatDashedNumber(salaryObj.min)}+ ${salaryObj.currency}/${salaryFrequency}`;
	else {
		salary = `${formatDashedNumber(salaryObj.min)} - ${formatDashedNumber(salaryObj.max)} ${
			salaryObj.currency
		}/${salaryFrequency}`;
	}
	return salary;
};
